import React, {useEffect, useState} from 'react';
import '../ChoosePersonStep.scss';
import DynaInput from "../../../../DynaView/DynaInput";
import DynaSelectBox from "../../../../DynaView/DynaSelectBox";
import {getOrganizationList} from "../../../InsuranceRequests";
import DynaTextarea from "../../../../DynaView/DynaTextarea";

const AddRealOrganizePerson = ({sendData, setSendData}) => {

  const [organizationList, setOrganizationList] = useState([])

  useEffect(() => {
    void getOrganizationList(setOrganizationList)
  }, []);

  return (
    <div className={"add-person-form"}>
      <DynaInput label={"کد ملی"}
                 name={"nationalId"}
                 className={"solid-dyna-input"}
                 placeholder={"کد ملی را وارد کنید"}
                 value={sendData?.nationalId}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"نام و نام خانوادگی"}
                 name={"fullName"}
                 className={"solid-dyna-input"}
                 placeholder={"نام و نام خانوادگی را وارد کنید"}
                 value={sendData?.fullName}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"شماره موبایل"}
                 name={"mobileNumber"}
                 className={"solid-dyna-input"}
                 placeholder={"شماره موبایل را وارد کنید"}
                 value={sendData?.mobileNumber}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaSelectBox options={organizationList}
                     hasFilter={true}
                     label={"انتخاب سازمان"}
                     className={"solid-dyna-input"}
                     value={sendData?.organizationId}
                     onChange={(data) => setSendData({...sendData, organizationId: data.value})}
      />
      <DynaInput label={"شماره تلفن"}
                 name={"telephone"}
                 className={"solid-dyna-input"}
                 placeholder={"شماره تلفن را وارد کنید"}
                 value={sendData?.telephone}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
      <DynaInput label={"شماره پرسنلی"}
                 name={"personnelNumber"}
                 className={"solid-dyna-input"}
                 placeholder={"شماره پرسنلی را وارد کنید"}
                 value={sendData?.personnelNumber}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />

      <div style={{gridColumn: "1 / -1"}}>
        <DynaTextarea label={"آدرس"}
                      name={"address"}
                      style={{height: '80px'}}
                      className={"solid-dyna-input"}
                      placeholder={"آدرس را وارد کنید"}
                      value={sendData?.address}
                      type={"text"}
                      setDataFromComponent={(data) => {
                        setSendData({...sendData, ...data})
                      }}
        />
      </div>
      <DynaInput label={"کد پستی"}
                 name={"postalCode"}
                 className={"solid-dyna-input"}
                 placeholder={"کد پستی را وارد کنید"}
                 value={sendData?.postalCode}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
    </div>
  );
};

export default AddRealOrganizePerson;